import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/cl_logo_horizontal.svg'


const _withScopeId = n => (_pushScopeId("data-v-9d6c3e3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-layout__content" }
const _hoisted_2 = { class: "app-layout__page" }
const _hoisted_3 = { class: "layout fluid gutter--xl" }
const _hoisted_4 = { class: "row footer justify--space-around" }
const _hoisted_5 = { class: "flex xs12 lg4" }
const _hoisted_6 = { class: "wrapper" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Chat Libs! Logo",
  src: _imports_0
}, null, -1))
const _hoisted_8 = { class: "flex xs12 lg4 text-right" }
const _hoisted_9 = { class: "wrapper" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divider" }, "•", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divider" }, "•", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "divider" }, "•", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: this.$route.path
        }))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, { to: "/" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_router_link, { to: {name: 'FAQ'} }, {
              default: _withCtx(() => [
                _createTextVNode("FAQ")
              ]),
              _: 1
            }),
            _createTextVNode(),
            _hoisted_10,
            _createVNode(_component_router_link, { to: {name: 'PrivacyPolicy'} }, {
              default: _withCtx(() => [
                _createTextVNode("Privacy Policy")
              ]),
              _: 1
            }),
            _createTextVNode(),
            _hoisted_11,
            _createVNode(_component_router_link, { to: {name: 'TermsOfService'} }, {
              default: _withCtx(() => [
                _createTextVNode("Terms of Service")
              ]),
              _: 1
            }),
            _createTextVNode(),
            _hoisted_12,
            _createTextVNode(" © 2022 Chat Libs! ")
          ])
        ])
      ])
    ])
  ]))
}